<!--<ng-container>-->
<!--  &lt;!&ndash;  TODO uncomment when implementing mobile only &ndash;&gt;-->
<!--  &lt;!&ndash;  <ng-container *ngIf="isMobileDevice else notMobileDevice">&ndash;&gt;-->

<!--  &lt;!&ndash;  <app-navbar></app-navbar>&ndash;&gt;-->
<!--</ng-container>-->

<div style="display: flex; flex: 1; align-items: center; justify-content: center; flex-direction: column;">
  <!--                <div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">-->
  <button class="createGabadoo" (click)="goToCreateGabaPage()" >
    <img src="../../../../assets/images/footer/reviews.png" alt="Icon" />
    <span>Create a Gabadoo</span>
  </button>
</div>


<div *ngFor="let review of reviews.slice().reverse()"
     style="display: flex; justify-content: center; align-items: center; flex-direction: row;">
  <mat-card class="active-review-card review-card" (click)="gabadooReviewClicked(review)">
    <mat-card-content>
      <div style="display: flex; justify-content: center; align-items: center; z-index: 1; flex-direction: column; width: 100%; height: 100%;">
        <h5 class="gabadoo-review-card-name-content">{{ review.childInfo.childName | titlecase }}</h5>
        <div class="review-info">
          <p class="review-date-value">{{ review.reviewDetails.createdAt | date :  "dd/MM/y"}}</p>
          <p class="review-date-value">{{review.reviewDetails.areaOfFocus | titlecase }}</p>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  <!--  Old code-->
  <!--      <button  (click)="gabadooReviewClicked(review)" class="gabadoo-review-card active-gabadoo-review-card" >-->
  <!--                              <span class="gabadoo-review-card-name">-->
  <!--                                {{ review.childInfo.childName | titlecase }} <br>-->
  <!--                            </span>-->
  <!--        <span class="gabadoo-review-card-description">-->
  <!--                              <strong>{{ review.reviewDetails.createdAt | date :  "dd/MM/y"}}</strong>-->
  <!--                              <p><strong>{{review.reviewDetails.areaOfFocus}}</strong></p>-->
  <!--                            </span>-->

  <!--      </button>-->
  <!-- <div style="display: flex; justify-content: center; align-items: center; flex-direction: row;"> -->
</div>

<div class="gabadooCardContainer">
  <button class="createGabadoo" >
    <img src="../../../../assets/images/footer/reviews@3x.png" alt="Icon"  width = "30px;"/>
    <span>Empty Gabadoo</span>
  </button>
</div>


















<!-- not mobile device -->
<!--  TODO uncomment when implementing mobile only -->
<ng-template #notMobileDevice>
  <div class="desktop-container">
    <div class="py-4 text-center header-image">
      <img class="logo-img" src="../../../../assets/images/logo/Logo.png" alt="Gabadoo Logo">
    </div>

    <div class="desktop-text-container">
      <h1 style="text-align: center;">You cannot access this page on a desktop</h1>
      <p>Please re-open on a mobile device</p>
    </div>
  </div>
</ng-template>


